import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <a href="http://www.grazianosgroup.com/">Grazianos</a> &copy; 2025 - 5.0-beta
      </footer>
    );
  }
}

export default Footer;
